import { submitEvent } from "./utils/tracking";

function reportMetricToDatadog(metric) {
  submitEvent("web_vital", {
    id: metric.id,
    name: metric.name,
    value: metric.value,
    rating: metric.rating,
    delta: metric.delta,
  });
}

const reportWebVitals = (onPerfEntry = reportMetricToDatadog) => {
  if (typeof onPerfEntry === "function") {
    import("web-vitals").then(
      ({ onCLS, onFCP, onFID, onINP, onLCP, onTTFB }) => {
        onCLS(onPerfEntry);
        onFID(onPerfEntry);
        onFCP(onPerfEntry);
        onINP(onPerfEntry);
        onLCP(onPerfEntry);
        onTTFB(onPerfEntry);
      },
    );
  }
};

export default reportWebVitals;
